import { createContext, useContext } from 'react'
import { type NameInputStore } from 'features/CreateOrEdit/NameInput/store/nameInputStore'

export const NameInputContext = createContext<NameInputStore | null>(null)

export const useNameInputContext = () => {
  const context = useContext(NameInputContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with NameInputContext')

  return context
}
